import { gql } from '@apollo/client';
import {
  getContextQueryVariables,
  getContextFilterClientExports,
  getContextFiltersQueryArguments,
} from '../../../utils/helpers/contextFilters';

export const GET_PASS_PLACEMENT_EVENTS = gql`
  query GetPassPlacementEvents(
    $teamId: Int!
    $competitionId: Int!
    $seasonId: Int!
    $playerId: Int!
    ${getContextQueryVariables()}
  ) {
    selectedCompetitionId @client @export(as: "competitionId")
    selectedPlayerId @client @export(as: "playerId")
    selectedSeasonId @client @export(as: "seasonId")
    selectedTeamId @client @export(as: "teamId")
    ${getContextFilterClientExports()}

    passEvents(
      first: 500
      eventFilters: { playerIds: [$playerId] }
      playFilters: {
        competitionId: $competitionId
        seasonId: $seasonId
        teamIds: [$teamId]
        ${getContextFiltersQueryArguments()}
      }
    ) {
      totalCount
      edges {
        node {
          id
          team {
            name
          }
          player {
            id
            name
            teamPosition {
              code
            }
            jerseyNumber
          }
          play {
            yardLine
            success
            touchdownWon
            yardsNet
            turnoverType
            downNegated
            id
            name
            drive {
              id
              name
            }
            explosive
          }
          game {
            id
            name
          }
          receiverPlayer {
            id
            name
            teamPosition {
              generalPosition
            }
            jerseyNumber 
          }
          x
          y
          endX
          endY
          duration
          passPlacementX
          passPlacementY
          success
          points
          passAirYards
        }
      }
    }
  }
`;
